import { render } from "./TestimonialsView.vue?vue&type=template&id=f24efbce"
import script from "./TestimonialsView.vue?vue&type=script&lang=js"
export * from "./TestimonialsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__